import gql from 'graphql-tag'
import { DataProxy } from '~/node_modules/apollo-cache/src/types/DataProxy'

import {
  GQLLocalMutationSetUiArgs,
  GQLLocalQuery,
} from '~/graphql/__generated__/interfacesLocal'

export const uiInitialState = {
  ui: {
    __typename: 'Ui',
    isLoginInProgress: false,
    mpPanelTranslationKey: null,
    openAdultConfirm: false,
    openGlossaryTerm: null,
    openHeaderTab: null,
    openVideoUrl: null,
    hideSidebar: false,
    openAddCart: null,
    showLoginModal: false,
    showSelectCardModal: false,
    openWishlist: null,
  },
}

export const GQL_LOCAL_UI = gql`
  {
    ui @client {
      isLoginInProgress
      openHeaderTab
      openAdultConfirm
      openGlossaryTerm
      mpPanelTranslationKey
      openVideoUrl
      hideSidebar
      openAddCart
      showLoginModal
      showSelectCardModal
      openWishlist
    }
  }
`

export const GQL_LOCAL_MUTATION_SET_UI = gql`
  mutation($ui: UiInput!) {
    setUi(ui: $ui) @client
  }
`

export const mutationLocalUi = {
  setUi: (
    _: {},
    args: GQLLocalMutationSetUiArgs,
    { cache }: { cache: DataProxy }
  ) => {
    const getUi = cache.readQuery({ query: GQL_LOCAL_UI }) as {
      ui: GQLLocalQuery
    }

    const mergeData = {
      ...getUi?.ui,
      ...args.ui,
    }

    cache.writeData({
      data: {
        ui: {
          __typename: 'Ui',
          ...mergeData,
        },
      },
    })
  },
}
